<template>
  <div class="view-tools">
    <b-container>
      <b-row>
        <b-col style="padding-bottom: 1rem; margin-top: 2.5rem;">
          <SearchBar
            v-model="searchForm"
            search-placeholder="Search deals by name or keyword"
            light-shadow
            full-country-names
            disable-address-search
            :on-submit="onSearchBarSubmit"
          />
        </b-col>
      </b-row>
      <b-row style="display: flex; margin: 0rem 0rem 2rem 0rem; ">
        <div
          :class="
            activeCategories && activeCategories.length === 0
              ? 'deals-filters-buttons-active_button'
              : 'deals-filters-buttons-button'
          "
          @click="clickToAll()"
        >
          All
        </div>
        <div v-for="category in this.toolCategories" :key="category._id">
          <div
            :class="
              activeCategories.includes(category._id)
                ? 'deals-filters-buttons-active_button'
                : 'deals-filters-buttons-button'
            "
            @click="clickToCategory(category._id)"
          >
            {{ category.title }}
          </div>
        </div>
      </b-row>
      <b-row class="pb-60">
        <div style="margin-left: 1rem; margin-right: 1rem;">
          <h2>Curated deals for the startups</h2>
          <p>
            Exclusive offers on amazing products for The Hub community members
          </p>
        </div>
      </b-row>
      <b-row class="pb-60">
        <ToolsPageContent :tools="tools" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SearchBar from '@/components/search/SearchBar';
import ToolsPageContent from '@/components/tools/ToolsPageContentProper';
import { buildMetaHead } from '@/helpers/meta';
import { isEmptyDeep } from '@/helpers/helpers';
import get from 'lodash/get';
import omitBy from 'lodash/omitBy';
import clone from 'lodash/clone';

export default {
  name: 'PageTools',
  components: {
    ToolsPageContent,
    SearchBar
  },
  head() {
    return buildMetaHead({
      title: 'Curated Deals for Startups',
      description:
        'Exclusive offers and free trials on amazing products for The Hub community members.',
      path: this.$route.path,
      imageUrl: process.env.BASE_URL + '/images/thehub_2023_tools.png'
    });
  },
  data() {
    const countryCode = this.$store.getters['meta/sitePreferredCountryCode'];
    // console.log('activeCategories init:', get(this.$route, 'query.categories'));
    const activeCategories = get(this.$route, 'query.categories') || [];
    return {
      searchForm: {
        search: get(this.$route, 'query.search'),
        countryCode: get(this.$route, 'query.countryCode', countryCode)
      },
      filters: {
        countryCode: get(this.$route, 'query.countryCode', countryCode),
        search: get(this.$route, 'query.search'),
        categories: get(this.$route, 'query.categories')
      },
      activeCategories:
        activeCategories && Array.isArray(activeCategories) ? activeCategories : [activeCategories]
    };
  },
  computed: {
    params() {
      const filters = omitBy(clone(this.filters), isEmptyDeep);
      if (this.page >= 2) {
        filters.page = this.page;
      }

      return filters;
    },
    tools() {
      return this.$store.state.tools.tools;
    },
    toolCategories() {
      return this.$store.getters['meta/toolCategories'];
    }
  },
  watch: {
    'searchForm.countryCode'(newValue, oldValue) {
      /**
       * trigger search whenever we change the country.
       */
      if (newValue !== oldValue) {
        this.filters.countryCode = this.searchForm.countryCode;
        this.$store.dispatch('meta/setPreferredCountryCode', this.filters.countryCode);
      }
    },
    activeCategories: {
      deep: true,
      handler() {
        // whenever a filter is changed, reset offset (page) to beginning
        this.page = 1;

        this.doSearch();
      }
    },
    filters: {
      deep: true,
      handler() {
        // whenever a filter is changed, reset offset (page) to beginning
        this.page = 1;

        this.doSearch();
      }
    }
  },
  async asyncData({ query, store, error }) {
    try {
      const params = {
        ...query
      };

      // if no `countryCode` defined, default to ip detected.
      const countryCode = store.getters['meta/sitePreferredCountryCode'];
      if (!params.countryCode) {
        params.countryCode = [countryCode];
      }

      await store.dispatch('tools/find', params);
    } catch (err) {
      error(err);
    }
  },
  mounted() {
    this.$router.push({
      path: `/deals`
    });
  },
  methods: {
    clickToCategory(categoryID) {
      // this.activeCategories.push(categoryID)
      if (!this.activeCategories.includes(categoryID)) {
        this.activeCategories.push(categoryID);
      } else {
        this.activeCategories = this.activeCategories.filter(
          (oldCategoryID) => oldCategoryID !== categoryID
        );
      }
      this.filters.categories = this.activeCategories;
      // console.log('this.activeCategories', this.activeCategories)
      // console.log('this.filters', this.filters)
      // this.doSearch()
    },
    clickToAll() {
      if (this.activeCategories && this.activeCategories.length === 0) {
      } else {
        this.activeCategories = [];
        this.filters.categories = this.activeCategories;
      }
    },
    onSearchBarSubmit() {
      this.filters.search = this.searchForm.search;
      this.filters.countryCode = this.searchForm.countryCode;
      this.filters.categories = this.activeCategories;

      this.doSearch();
    },
    async doSearch() {
      await this.$store.dispatch('tools/find', this.params);

      this.$router.push({
        query: this.params
      });
    }
  }
};
</script>

<style scoped lang="scss">
.view-tools {
  background-color: $gray-100;
}
.deals-filters-buttons-button {
  cursor: pointer;
  border: 1px solid #ced0d5;
  color: #1f2430;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  font-size: 0.9rem;
  user-select: none;
}
.deals-filters-buttons-active_button {
  cursor: pointer;
  border: 1px solid #4440db;
  background-color: #4440db;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  font-size: 0.9rem;
  user-select: none;
}
</style>
